import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';

/**
 * AccessDenied page component
 * 
 * Shown when user tries to access a resource they don't have permission for.
 */
const AccessDenied: React.FC = () => {
  const location = useLocation();
  const from = (location.state as any)?.from?.pathname || '/dashboard';

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="mt-5">
              <CardBody className="p-5">
                <div className="text-center">
                  <div className="mb-4">
                    <FeatherIcon
                      icon="lock"
                      className="text-danger"
                      size={64}
                    />
                  </div>
                  <h3 className="mb-3">Access Denied</h3>
                  <p className="text-muted mb-4">
                    You don't have permission to access this resource.
                  </p>
                  <div className="d-flex gap-2 justify-content-center">
                    <Link to={from} className="btn btn-primary">
                      <FeatherIcon icon="arrow-left" className="me-1" size={16} />
                      Go Back
                    </Link>
                    <Link to="/dashboard" className="btn btn-outline-primary">
                      <FeatherIcon icon="home" className="me-1" size={16} />
                      Dashboard
                    </Link>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AccessDenied;
